<agpr-text-input-chips
    [id]="id"
    [disabled]="disabled"
    [placeholder]="placeholder ? (placeholder | localize) : undefined"
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit(value)"
    [chipValidations]="chipValidations"
    [clearAllChipsTooltip]="clearAllChipsTooltip"
    [showDuplicateErrorKey]="showDuplicateErrorKey"
    [splitOnPattern]="splitOnPattern"
    [header]="header"
    [tooltip]="tooltip"
    [ariaLabel]="ariaLabel"
    [ariaDescribedBy]="ariaDescribedBy"
    [ariaInvalid]="ariaInvalid"
></agpr-text-input-chips>
